import React, {useContext, useEffect, useState} from 'react';
import {Table, Popover, Whisper, Modal} from 'rsuite';
import 'rsuite/dist/styles/rsuite-default.css'
import {makeStyles} from "@material-ui/core/styles";
import EncodeSansLight from "../../assets/fonts/Encode_Sans/EncodeSans-Light.ttf";
import {useHistory} from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField/TextField";
import Loading from "../Loading";
import {useMutation, gql} from "@apollo/client";
import axios from "axios";
import AuthContext from "../../context/AuthContext";
import {Button} from "@material-ui/core";
import MasterContext from "../../context/MasterContext";

const {Column, HeaderCell, Cell, Pagination} = Table;

const CHANGE_AFFINITY_ACTIVE_CONDITION = gql`
    mutation MyMutation($idAfinidad: Int, $Activa: Boolean) {
      update_General_Afinidades(where: {idAfinidad: {_eq: $idAfinidad}}, _set: {Activa: $Activa}) {
        affected_rows
      }
    }
`;

const useStyle = makeStyles(() => ({
    alertField: {
        '& label.Mui-focused': {
            color: "#BB0D66",
        },
    },
    centerVertically: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
    },
    endHorizontally: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "flex-end",
        alignItems: "center",
    },
    formTitle: {
        fontFamily: "Poppins",
        fontWeight: '500',
        fontSize: "20px",
        color: "#bb0d66",
        textAlign: "center"
    },
    modalColumn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly"
    },
    modalSubtitle: {
        fontFamily: "Poppins",
        fontWeight: "500",
        fontSize: "16px",
        textAlign: "center"
    },
    modalText: {
        fontFamily: "Poppins",
        fontWeight: "500",
        fontSize: "16px",
        textAlign: 'center'
        // color:'#'
    },
    coloredModalText: {
        fontFamily: "Poppins",
        fontWeight: "300",
        fontSize: "16px",
        textAlign: 'center',
        lineHeight:"1",
        color: '#BB0D66'
    },
    divRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        width: "90%"
    },
    divColumn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "50%",
    },
    divColumn1: {
        display: "flex",
        flexDirection: "column",
        width: "50%",
    },
    btnShare: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "14px",
        background: "#BB0D66",
        padding: "10px 30px 10px 30px",
        margin: "10px 5px -10px 5px",
        textDecoration: "none",
        border: "solid #BB0D66 0px",
        fontFamily: EncodeSansLight,
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttonCancel: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#9A9A9A",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttonConfirm: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    disabledCell: {
        backgroundColor: "#c2c2c2",
        color: "#727272"
    },
    actionButtons: {
        cursor: "pointer",
        color: "#bb0d66",
        fontSize: "12px"
    },
    actionButtonsSeparator: {
        color: "#bb0d66",
        fontSize: "12px"
    },
    actionButtonsDiv: {
        display: "flex",
        height: "24px",
        alignItems:"center"
    }
}))

const Mailto = ({email, subject, body, children}) => {
    return (
        <a href={`mailto:${email}?subject=${encodeURIComponent(subject) || ''}&body=${encodeURIComponent(body) || ''}`}>{children}</a>
    );
};

const sendWapp = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}

function currencyFormat(numString) {
    numString = numString.toString().replace(/\./g, "")
    numString = numString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return numString
}

function AffinitiesTable() {
    const {affinitiesInfo, handleModified, unidadesNegocioOptions} = useContext(MasterContext);
    const [rows, setRows] = useState(null);
    const [filteredEmisiones, setFilteredEmisiones] = useState(null);
    const classes = useStyle();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
    const [affinityInfo, setAffinityInfo] = useState('');
    const history = useHistory();
    const {authToken} = useContext(AuthContext);

    //ENABLE DISABLE
    const [enableDisableAffinity] = useMutation(CHANGE_AFFINITY_ACTIVE_CONDITION);

    //PAGINATION
    const [page, setPage] = useState(1)
    const [displayLength, setDisplayLength] = useState(10)

    //SEARCH
    const handleSearchValueChange = (event) => {
        if (event.target.value.length >= 3) {
            let filtered = rows.filter((item) =>
                item["CIntermediario"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["COrganizacion"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["Afinidad"].toUpperCase().includes(event.target.value.toUpperCase())
            );

            setFilteredEmisiones(filtered);
        } else setFilteredEmisiones(null)
    };

    //GET AND FILTER DATA TABLE

    function getData() {
        return rows.filter((v, i) => {
            const start = displayLength * (page - 1);
            const end = start + displayLength;
            return i >= start && i < end;
        });
    }

    const getAffinitiesTableInfo = () => {
        setRows(null);
        setFilteredEmisiones(null)
        handleModified()
    }

    //DELETE AFFINITY
    const deleteAffinity = (idAffinity) => {
        setRows(null);
        setModalDeleteOpen(false)
        let url = process.env.REACT_APP_BACK_SERVER + '/EliminarAfinidad'

        axios.post(url, {id: idAffinity}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        }).then(() => {
            getAffinitiesTableInfo()
        })
    }

    //CELL COMPONENT
    const NameCell = ({rowData, dataKey, ...props}) => {
            const activeCell = rowData['Activo']

            if (dataKey === 'verMas') {
                return (
                    <Cell {...props} className={!activeCell && classes.disabledCell}>
                    <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        {activeCell
                            ? <a style={{cursor: "pointer"}} onClick={() => {
                                setModalOpen(!modalOpen)
                                setAffinityInfo(rowData)
                            }}>Ver más</a>
                            : <p style={{cursor: "default"}}>Ver más</p>
                        }
                    </span>
                    </Cell>
                );
            }

            if (dataKey === 'unidad_de_negocio') {
                return (
                    <Cell {...props} className={!activeCell && classes.disabledCell}>
                    <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        {rowData[dataKey]
                            ? <p>{unidadesNegocioOptions.find(k => k.value === rowData[dataKey])['label']}</p>
                            : <p style={{color: '#ee7474', fontSize:"12px"}}>Sin asignar</p>
                        }
                    </span>
                    </Cell>
                );
            }
            if (dataKey === 'gift_card') {
                return (
                    <Cell {...props} className={!activeCell && classes.disabledCell}>
                    <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        {rowData[dataKey] > 0
                            ? <p>${currencyFormat(rowData[dataKey])}</p>
                            : <p> - </p>
                        }
                    </span>
                    </Cell>
                );
            }

            if (dataKey === 'Asesores') {
                const speaker = (
                    <Popover>
                        <p>
                            <b>Asesores Asignados:</b> {`${rowData['Asesores']}`}{' '}
                        </p>
                    </Popover>
                );
                return (
                    <Cell {...props} className={!activeCell && classes.disabledCell}>
                        <Whisper placement="top" speaker={speaker}>
                            <div>{rowData[dataKey].toString()}</div>
                        </Whisper>
                    </Cell>
                );
            }

            if (dataKey === 'ProductosString') {
                const speaker = (
                    <Popover>
                        <p>
                            <b>Productos Activados:</b> {`${rowData['ProductosString']}`}{' '}
                        </p>
                    </Popover>
                );
                return (
                    <Cell {...props} className={!activeCell && classes.disabledCell}>
                        <Whisper placement="top" speaker={speaker}>
                            {rowData[dataKey] !== undefined ?
                                <div>{rowData[dataKey].toLocaleString()}</div>
                                :
                                <div>Sin datos</div>
                            }
                        </Whisper>
                    </Cell>
                );
            }

            return (
                <Cell {...props} className={!activeCell && classes.disabledCell}>
                    {rowData[dataKey].toLocaleString()}
                </Cell>
            );
        }
    ;

    useEffect(() => {
        if (filteredEmisiones === null)
            setRows(affinitiesInfo)
        else
            setRows(filteredEmisiones);
    }, [filteredEmisiones, affinitiesInfo]);

    if (!rows) return (<Loading/>);
    return (
        <React.Fragment>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexDirection: 'row', marginTop: '8px', justifyContent: "center"}}>
                    <h3 className={classes.formTitle}>Gestor de afinidades</h3>
                </div>

                <div className={classes.endHorizontally} style={{margin: "0 48px 8px 0", padding: "8px 0px"}}>
                    <div className={classes.centerVertically} style={{marginRight: "8px"}}><SearchIcon
                        style={{color: "#BB0D66"}}/></div>
                    <div className={classes.centerVertically} style={{marginTop: "-24px"}}>
                        <TextField
                            label="Buscar"
                            className={classes.alertField}
                            onChange={(e) => handleSearchValueChange(e)}/>
                    </div>
                </div>

                < Table
                    height={400}
                    width={950}
                    data={getData()}
                    hover={false}
                >
                    <Column width={90} fixed sortable resizable>
                        <HeaderCell>Afinidad</HeaderCell>
                        <NameCell dataKey="Afinidad"/>
                    </Column>
                    <Column width={100} resizable>
                        <HeaderCell>Unidad de Negocio</HeaderCell>
                        <NameCell dataKey="unidad_de_negocio"/>
                    </Column>
                    <Column width={130}>
                        <HeaderCell>Cód. Intermediario</HeaderCell>
                        <NameCell dataKey="CIntermediario"/>
                    </Column>
                    <Column width={120}>
                        <HeaderCell>Cód. Organizador</HeaderCell>
                        <NameCell dataKey="COrganizacion"/>
                    </Column>
                    <Column width={180}>
                        <HeaderCell>Asesores</HeaderCell>
                        <NameCell dataKey="Asesores"/>
                    </Column>
                    <Column width={180}>
                        <HeaderCell>Responsable</HeaderCell>
                        <NameCell dataKey="Responsable"/>
                    </Column>
                    <Column width={180}>
                        <HeaderCell>Productos</HeaderCell>
                        <NameCell dataKey="ProductosString"/>
                    </Column>
                    <Column width={80}>
                        <HeaderCell>Gift Card</HeaderCell>
                        <NameCell dataKey="gift_card"/>
                    </Column>

                    <Column width={140}>
                        <HeaderCell>Información Adicional</HeaderCell>
                        <NameCell dataKey="verMas"/>
                    </Column>


                    <Column width={175} fixed="right">
                        <HeaderCell>Acciones</HeaderCell>

                        <Cell>
                            {rowData => {

                                function handleEdit() {
                                    history.push({
                                        pathname: '/u/m/new-affinity',
                                        state: {
                                            data: rowData,
                                        }
                                    })
                                }

                                function handleDisable(rowData) {
                                    setRows(null);
                                    enableDisableAffinity({
                                        variables: {
                                            idAfinidad: rowData.id,
                                            Activa: !rowData.Activo
                                        }
                                    }).then(() => {
                                        getAffinitiesTableInfo()
                                    })
                                }

                                function handleDelete(rowData) {
                                    setAffinityInfo(rowData)
                                    setModalDeleteOpen(true)
                                }

                                return (
                                    <div className={classes.actionButtonsDiv}>
                                        <a onClick={handleEdit} className={classes.actionButtons}>Editar</a>
                                        <p className={classes.actionButtonsSeparator}>&nbsp;|&nbsp;</p>
                                        <a onClick={() => handleDisable(rowData)} className={classes.actionButtons}>
                                            {rowData['Activo'] ? "Deshabilitar" : "Habilitar"}
                                        </a>
                                        <p className={classes.actionButtonsSeparator}>&nbsp;|&nbsp;</p>
                                        <a onClick={() => handleDelete(rowData)} className={classes.actionButtons}>Eliminar</a>
                                    </div>
                                );
                            }}
                        </Cell>
                    </Column>
                </Table>
                <Pagination
                    lengthMenu={[
                        {
                            value: 10,
                            label: 10
                        },
                        {
                            value: 20,
                            label: 20
                        }
                    ]}
                    activePage={page}
                    displayLength={displayLength}
                    total={rows.length}
                    onChangePage={(dataKey) => setPage(dataKey)}
                    onChangeLength={(dataKey) => setDisplayLength(dataKey)}
                />

                <Modal backdrop={true} show={modalDeleteOpen} onHide={() => setModalDeleteOpen(!modalDeleteOpen)}
                       style={{top: '10%'}}>
                    <Modal.Header/>
                    <Modal.Body>
                        <div className={classes.modalColumn}>
                            <p className={classes.formTitle} style={{marginBottom: "8px"}}>¿Está seguro de
                                eliminar la afinidad?</p>

                            <div className={classes.divRow}>
                                <div className={classes.divColumn}>
                                    <img src={affinityInfo['logo']} width={"200px"} height={"200px"}
                                         style={{objectFit: 'contain'}}/>
                                </div>
                                <div className={classes.divColumn1}>
                                    <p className={classes.modalSubtitle} style={{marginTop:"8px"}}>Nombre:</p>
                                    <p className={classes.coloredModalText}>{affinityInfo['Afinidad']}</p>

                                    <p className={classes.modalSubtitle} style={{marginTop:"16px"}}>Responsable:</p>
                                    <p className={classes.coloredModalText}>{affinityInfo['Responsable']}</p>

                                    <p className={classes.modalSubtitle} style={{marginTop:"16px"}}>Asesores:</p>
                                    {affinityInfo['Asesores'] !== undefined &&
                                        affinityInfo['Asesores'].map(asesor =>
                                            <p className={classes.coloredModalText}>{asesor}</p>
                                        )
                                    }
                                </div>
                            </div>

                            <div style={{marginTop: "8px", marginBottom:"-16px"}}>
                                <Button variant="contained" className={classes.buttonCancel} onClick={() => setModalDeleteOpen(!modalDeleteOpen)}>
                                    Cancelar
                                </Button>
                                <Button variant="contained" className={classes.buttonConfirm} onClick={() => deleteAffinity(affinityInfo['id'])}>
                                    Eliminar
                                </Button>
                            </div>


                        </div>

                    </Modal.Body>
                </Modal>


                <Modal backdrop={true} show={modalOpen} onHide={() => setModalOpen(!modalOpen)} style={{top: '10%'}}>
                    <Modal.Header>

                    </Modal.Header>
                    <Modal.Body>
                        <div className={classes.modalColumn}>
                            <p className={classes.formTitle} style={{marginBottom: "20px"}}>Información de la
                                afinidad</p>

                            <p className={classes.modalSubtitle}>Link:</p>
                            <div style={{
                                display: 'flex', width: '100%', padding: '16px'
                            }}>
                                <a className={classes.modalText} href={affinityInfo['Link']}
                                   target="_blank">{affinityInfo['Link']}</a>
                            </div>

                            <p className={classes.modalSubtitle}>QR:</p>
                            <img src={affinityInfo['QR']} width={"200px"} height={"200px"}/>


                            <div>
                                <Mailto email="" subject="Bienvenido a Sancor"
                                        body="Su empresa ya puede comenzar a operar bajo el convenio.">
                                    <button className={classes.btnShare}>
                                        Compartir vía Email
                                    </button>
                                </Mailto>

                                <button className={classes.btnShare} onClick={
                                    () => sendWapp('https://wa.me/?text=Bienvenido%20al%20programa%20de%20afinidades%20de%20Sancor%20Seguros.%20Estos%20son%20los%20datos%20que%20necesitará%20para%20comenzar%20a%20operar:%20' + affinityInfo['Link'])
                                }>
                                    Compartir vía WhatsApp
                                </button>
                            </div>

                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        </React.Fragment>

    );
}

export default AffinitiesTable;